module.exports = __webpack_public_path__ + "static/media/silkollor.0217e9ec.webp";